import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Search, Menu, X, Globe, Accessibility, ChevronDown } from 'lucide-react';
export function Header() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const navItems = [{
    name: 'About MAAIF',
    hasDropdown: true,
    dropdownContent: [{
      title: 'Vision & Mission',
      link: '/about/vision-mission'
    }, {
      title: 'Ministry Structure',
      link: '/about/structure'
    }, {
      title: 'Directorate of Animal Resources',
      link: '/about/animal-resources'
    }, {
      title: 'Directorate of Crop Resources',
      link: '/about/crop-resources'
    }, {
      title: 'Directorate of Fisheries Resources',
      link: '/about/fisheries-resources'
    }, {
      title: 'Directorate of Agricultural Extension Services',
      link: '/about/extension-services'
    }, {
      title: 'Leadership',
      link: '/about/leadership'
    }, {
      title: 'Contact Us',
      link: '/contact'
    }]
  }, {
    name: 'Services & Applications',
    hasDropdown: true,
    dropdownContent: [{
      title: 'Import & Export',
      link: '/import-export'
    }, {
      title: 'Guidelines & Services Center',
      link: '/guidelines-services'
    }, {
      title: 'Licensing',
      link: '/licensing'
    }, {
      title: 'Applications',
      link: '/applications'
    }]
  }, {
    name: 'Programs & Projects',
    hasDropdown: true,
    dropdownContent: [{
      title: 'MAAIF Projects',
      link: '/projects'
    }, {
      title: 'Programs',
      link: '/programs'
    }, {
      title: 'COCTU',
      link: '/coctu'
    }, {
      title: 'CDOUGA',
      link: '/cdouga'
    }, {
      title: 'DDA',
      link: '/dda'
    }, {
      title: 'NAADS',
      link: '/naads'
    }, {
      title: 'NARO',
      link: '/naro'
    }, {
      title: 'NAGRC&DB',
      link: '/nagrcdb'
    }, {
      title: 'UCDA',
      link: '/ucda'
    }]
  }, {
    name: 'Data & Statistics',
    hasDropdown: true,
    dropdownContent: [{
      title: 'Sector Statistics',
      link: '/sector-statistics'
    }, {
      title: 'Production Data',
      link: '/production-data'
    }, {
      title: 'Market Prices',
      link: '/market-prices'
    }, {
      title: 'Trade Data',
      link: '/trade-data'
    }]
  }, {
    name: 'News & Media',
    hasDropdown: true,
    dropdownContent: [{
      title: 'Media',
      link: '/media'
    }, {
      title: 'Press Releases',
      link: '/media?tab=Press+Releases'
    }, {
      title: 'Photo Gallery',
      link: '/media?tab=Photo+Gallery'
    }, {
      title: 'Events',
      link: '/media?tab=Events'
    }]
  }, {
    name: 'Resources',
    hasDropdown: true,
    dropdownContent: [{
      title: 'Library',
      link: '/resources'
    }, {
      title: 'Publications',
      link: '/resources'
    }, {
      title: 'Opportunities',
      link: '/opportunities'
    }, {
      title: 'Weather Advisory',
      link: '/weather-advisory'
    }]
  }];
  return <header className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm font-sans" data-id="element-173">
      {/* Uganda Flag Stripe */}
      <div className="h-2 w-full flex" data-id="element-174">
        <div className="h-full w-1/3 bg-black" data-id="element-175"></div>
        <div className="h-full w-1/3 bg-uganda-yellow" data-id="element-176"></div>
        <div className="h-full w-1/3 bg-uganda-red" data-id="element-177"></div>
      </div>

      {/* Top Utility Bar */}
      <div className="bg-uganda-green text-white py-1.5 px-4 md:px-8 text-xs md:text-sm flex justify-between items-center" data-id="element-178">
        <div className="hidden md:flex items-center space-x-4" data-id="element-179">
          <span data-id="element-180">Official MAAIF Website for the Government of Uganda</span>
        </div>
        <div className="flex items-center space-x-4 ml-auto" data-id="element-181">
          <button className="flex items-center hover:text-uganda-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-uganda-yellow rounded px-1" data-id="element-182">
            <Globe className="w-4 h-4 mr-1" data-id="element-183" /> English
          </button>
          <button className="flex items-center hover:text-uganda-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-uganda-yellow rounded px-1" data-id="element-184">
            <Accessibility className="w-4 h-4 mr-1" data-id="element-185" /> Accessibility
          </button>
          <a href="#" className="flex items-center hover:text-uganda-yellow transition-colors focus:outline-none focus:ring-2 focus:ring-uganda-yellow rounded px-1 border-l border-white/30 pl-4" data-id="element-186">
            Staff Login
          </a>
        </div>
      </div>

      {/* Main Header */}
      <div className="px-4 md:px-8 py-4 flex justify-between items-center bg-white" data-id="element-187">
        {/* Logo Area */}
        <Link to="/" className="flex items-center space-x-3 cursor-pointer" data-id="element-188">
          <div className="w-12 h-12 flex items-center justify-center overflow-hidden" data-id="element-189">
            <img src="https://cdn.magicpatterns.com/uploads/ncbNXNqcQkdode5pLbsA1p/Coat_of_arms_of_Uganda.svg_(1).png" alt="Uganda Coat of Arms" className="w-12 h-12 object-contain" data-id="element-190" />
          </div>
          <div className="flex flex-col" data-id="element-191">
            <span className="font-bold text-uganda-black leading-tight text-sm md:text-lg" data-id="element-192">
              Ministry of Agriculture,
            </span>
            <span className="font-bold text-uganda-green leading-tight text-sm md:text-lg" data-id="element-193">
              Animal Industry and Fisheries
            </span>
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/aTnR3zWKoe5uV8XL5DYkSp/Flag_of_Uganda.svg.png" alt="Uganda Flag" className="w-16 h-12 object-cover rounded-sm ml-2" data-id="element-194" />
        </Link>

        {/* Desktop Search */}
        <div className="hidden lg:flex items-center flex-1 max-w-3xl mx-8" data-id="element-195">
          <div className="relative w-full" data-id="element-196">
            <input type="text" placeholder="Search services, reports, news..." className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-full focus:outline-none focus:border-uganda-green focus:ring-1 focus:ring-uganda-green" data-id="element-197" />
            <button className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-uganda-green" data-id="element-198">
              <Search className="w-5 h-5" data-id="element-199" />
            </button>
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="lg:hidden text-uganda-black p-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-200">
          {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-201" /> : <Menu className="w-6 h-6" data-id="element-202" />}
        </button>
      </div>

      {/* Desktop Navigation */}
      <nav className="hidden lg:block border-t border-gray-100 bg-white" data-id="element-203">
        <div className="max-w-[1300px] mx-auto px-8 flex justify-center gap-[30px]" data-id="element-204">
          {navItems.map(item => <div key={item.name} className="relative group" onMouseEnter={() => setActiveDropdown(item.name)} onMouseLeave={() => setActiveDropdown(null)} data-id="element-205">
              <button className="flex items-center py-4 font-semibold text-uganda-black hover:text-uganda-green transition-colors focus:outline-none" style={{
            fontSize: '15px'
          }} data-id="element-206">
                {item.name}
                {item.hasDropdown && <ChevronDown className="w-4 h-4 ml-1" data-id="element-207" />}
              </button>

              {/* Mega Menu Dropdown */}
              {item.hasDropdown && activeDropdown === item.name && <div className="absolute top-full left-0 w-64 bg-white shadow-lg border border-gray-100 rounded-b-md py-2 z-50" data-id="element-208">
                  {item.dropdownContent?.map((link, idx) => <a key={idx} href={link.link} className="block px-4 py-2 text-sm text-gray-700 hover:bg-uganda-light-green hover:text-uganda-green" data-id="element-209">
                      {link.title}
                    </a>)}
                </div>}
            </div>)}
        </div>
      </nav>

      {/* Mobile Navigation */}
      {isMobileMenuOpen && <div className="lg:hidden bg-white border-t border-gray-100 max-h-[calc(100vh-120px)] overflow-y-auto" data-id="element-210">
          <div className="p-4" data-id="element-211">
            <div className="relative w-full mb-4" data-id="element-212">
              <input type="text" placeholder="Search..." className="w-full pl-4 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-uganda-green" data-id="element-213" />
              <Search className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 w-5 h-5" data-id="element-214" />
            </div>
            <div className="flex flex-col" data-id="element-215">
              {navItems.map(item => <div key={item.name} data-id="element-216">
                  <button onClick={() => item.hasDropdown && setActiveDropdown(activeDropdown === item.name ? null : item.name)} className="flex justify-between items-center w-full py-3 border-b border-gray-100 text-left font-medium text-uganda-black" data-id="element-217">
                    {item.name}
                    {item.hasDropdown && <ChevronDown className={`w-4 h-4 transition-transform ${activeDropdown === item.name ? 'rotate-180' : ''}`} data-id="element-218" />}
                  </button>
                  {item.hasDropdown && activeDropdown === item.name && <div className="bg-gray-50 py-1" data-id="element-219">
                      {item.dropdownContent?.map((link, idx) => <a key={idx} href={link.link} className="block px-6 py-2.5 text-sm text-gray-700 hover:text-uganda-green hover:bg-green-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-220">
                          {link.title}
                        </a>)}
                    </div>}
                </div>)}
            </div>
          </div>
        </div>}
    </header>;
}